<template>
  <div class="wrap talk">
    <header>
      <h1><a href="#" class="logo"></a></h1>
    </header>
    <div class="container">
      <main class="content">
        <article class="certification">
          <section class="txt tit">
            <h1>중고폰 기부 신청서</h1>
          </section>
          <section>
            <div class="box row row_c row_jsc">
              <p>
                기부 신청하신 제품에 대해 연말 정산 소득공제를 원하시는 경우,
                아래의 내용을 입력해 주시기 바랍니다. 수집된 개인정보는 기부처인
                세이브더칠드런에 전달되며,오로지 기부확인을 위해서만 사용됩니다.
              </p>
            </div>
          </section>
          <section>
            <div class="con-box">
              <h2>기부 신청 제품</h2>
              <div
                v-if="searchedData.product.mobile === true"
                class="item row row_jsb"
              >
                <span class="item-tit">휴대폰 종류</span>
                <span class="item-con taR">{{
                  searchedData.product.modlNm
                }}</span>
              </div>
              <div v-else class="item row row_jsb">
                <span class="item-tit">종류</span>
                <span class="item-con taR">{{
                  searchedData.product.cate01Nm
                }}</span>
              </div>
              <div class="item row row_jsb bg">
                <span class="item-tit">예상 기부 금액</span>
                <span class="item-con en taR">{{
                  searchedData.dntnAmt | currency
                }}</span>
              </div>
            </div>
            <DxValidationGroup ref="validationGroup">
              <div class="con-box">
                <h2>무기명 기부 신청</h2>
                <div class="check-wrap">
                  <input
                    type="checkbox"
                    id="check"
                    class="checkbox"
                    v-model="checkboxObj.noname"
                    @change="() => onNonameChecked(checkboxObj.noname)"
                  />
                  <label for="check"></label>
                  <span
                    >소득공제를 원하지 않으시면 무기명 기부를 선택해
                    주세요.</span
                  >
                </div>
              </div>
              <div class="con-box">
                <h2>
                  소득공제 신청<span
                    >소득공제를 원하지 않으시면 이름만 입력해 주세요.</span
                  >
                </h2>
                <div class="form-wrap">
                  <dl class="row row_jsb row_ac">
                    <dt>이름</dt>
                    <dd>
                      <DxTextBox
                        v-model="donate.dntnCstmNm"
                        maxLength="20"
                        :readOnly="checkboxObj.noname"
                      >
                        <DxValidator>
                          <DxRequiredRule message="이름을 입력해 주세요." />
                        </DxValidator>
                      </DxTextBox>
                    </dd>
                  </dl>
                  <dl class="row row_jsb row_ac">
                    <dt>주민번호</dt>
                    <dd>
                      <DxTextBox
                        v-model="donate.dntnCstmIdntNum"
                        placeholder="- 없이 숫자만 기재"
                        maxLength="13"
                        :readOnly="checkboxObj.noname"
                        @input="onlyNumber"
                        ref="account"
                      >
                        <DxValidator>
                          <DxRequiredRule
                            v-if="!checkboxObj.noname"
                            message="주민번호를 입력해 주세요."
                          />
                          <DxStringLengthRule
                            v-if="!checkboxObj.noname"
                            :min="13"
                            :max="13"
                            message="주민번호가 유효하지 않습니다."
                          />
                          <DxCustomRule
                            v-if="!checkboxObj.noname"
                            :validation-callback="validAccount"
                            message="주민번호가 유효하지 않습니다."
                          />
                          <!-- <DxStringLengthRule v-if="!checkboxObj.noname && donate.dntnCstmIdntNum" :min="13" :max="13" message="주민번호가 유효하지 않습니다." />
                                          <DxCustomRule v-if="!checkboxObj.noname && donate.dntnCstmIdntNum" :validation-callback="validAccount" message="주민번호가 유효하지 않습니다." /> -->
                        </DxValidator>
                      </DxTextBox>
                    </dd>
                  </dl>
                </div>
              </div>
            </DxValidationGroup>
            <div class="con-box psr ag">
              <h2 class="agree">
                <input
                  type="checkbox"
                  id="agree"
                  class="agree_chk"
                  ref="check-00"
                  v-model="checkboxObj.checkedAll"
                  @change="() => onCheckboxAllChanged(checkboxObj.checkedAll)"
                />
                <label for="agree"></label>
                <span>기부 신청 유의사항 전체동의</span>
              </h2>
              <div class="agree-wrap">
                <div class="check-wrap row">
                  <input
                    type="checkbox"
                    id="check-01"
                    class="checkbox"
                    v-model="checkboxObj.checkedValues"
                    value="01"
                    @change="onCheckboxChanged"
                  />
                  <label for="check-01"></label>
                  <span class="agree-chk">개인정보 수집 및 이용 동의</span>
                </div>
                <div class="agree-con">
                  개인정보의 수집ㆍ이용 목적 : 중고폰을 기명 기부시 연말정산
                  처리의 목적으로 주민등록번호를 수집함<br />
                  ※ 「소득세법」 제160조의3, 동법 시행령 제208조의3,
                  「법인세법」 제112조의2, 동법 시행령 제155조의2에 의거하여
                  처리 2. 수집하는 개인정보의 항목 : (필수) 이름 , 주민번호<br />
                  개인정보의 보유ㆍ이용 기간 : 수집일로 부터 5년<br />
                  귀하께서는 본 안내에 따른 개인정보 수집. 이용에 대하여 동의를
                  거부 할 권리가 있습니다. 다만, 동의를 거부하는 경우에 기명
                  기부가 거부 될 수 있음을 알려드립니다<br />
                </div>
              </div>
              <div class="agree-wrap">
                <div class="check-wrap row">
                  <input
                    type="checkbox"
                    id="check-02"
                    class="checkbox"
                    v-model="checkboxObj.checkedValues"
                    value="02"
                    @change="onCheckboxChanged"
                  />
                  <label for="check-02"></label>
                  <span class="agree-chk">도난/분실 제품 처리 동의</span>
                </div>
                <div class="agree-con">
                  기부 신청한 제품이 도난/분실 등록된 제품일 경우 기부 신청이
                  취소되고 법적 조치를 취합니다.
                </div>
              </div>
              <div class="agree-wrap">
                <div class="check-wrap row">
                  <input
                    type="checkbox"
                    id="check-03"
                    class="checkbox"
                    v-model="checkboxObj.checkedValues"
                    value="03"
                    @change="onCheckboxChanged"
                  />
                  <label for="check-03"></label>
                  <span class="agree-chk">침수, 고장 제품 처리 동의</span>
                </div>
                <div class="agree-con">
                  기부 신청한 제품이 침수 이력이 있거나 심각한 고장이 있는
                  경우(제품 파손으로 작동이 되지 않거나, 하드웨어 Board가 불량인
                  경우, 전원이 들어오지 않는 경우) 기부 신청이 취소될 수 있는
                  것에 동의합니다.
                </div>
              </div>
              <div class="agree-wrap">
                <div class="check-wrap row">
                  <input
                    type="checkbox"
                    id="check-04"
                    class="checkbox"
                    v-model="checkboxObj.checkedValues"
                    value="04"
                    @change="onCheckboxChanged"
                  />
                  <label for="check-04"></label>
                  <span class="agree-chk">계정 삭제 협조 동의</span>
                </div>
                <div class="agree-con">
                  기부 신청한 제품이 안드로이드폰인 경우 구글, 삼성 계정 삭제.
                  아이폰인 경우 iCloud 계정 로그아웃을 하지않은 경우, 안내에
                  따라 추후 계정 삭제에 협조해야 합니다. 계정 삭제가 되지 않은
                  경우, 기부 신청이 취소될 수 있는 것에 동의합니다.
                </div>
              </div>
              <div class="agree-wrap">
                <div class="check-wrap row">
                  <input
                    type="checkbox"
                    id="check-05"
                    class="checkbox"
                    v-model="checkboxObj.checkedValues"
                    value="05"
                    @change="onCheckboxChanged"
                  />
                  <label for="check-05"></label>
                  <span class="agree-chk">데이터 완전 삭제 동의</span>
                </div>
                <div class="agree-con">
                  기부 신청한 제품의 모든 데이터를 복원할 수 없도록 삭제하는
                  것에 동의합니다.
                </div>
              </div>
            </div>
          </section>
          <div class="btn-wrap">
            <a
              href="javascript:;"
              class="talk-btn btn-black"
              @click="donateApply"
              >기부 신청 하기</a
            >
          </div>
        </article>
        <div class="cs-center row row_ac row_jsc">
          <span class="qa">고객센터 문의 </span>
          <span><a href="tel:1877-5446" class="en phone">1877-5446</a></span>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import AppConfig from "@/config";

// DevExtreme
import DxTextBox from "devextreme-vue/text-box";
import DxValidationGroup from "devextreme-vue/validation-group";
import {
  DxValidator,
  DxRequiredRule,
  DxStringLengthRule,
  DxCustomRule,
} from "devextreme-vue/validator";

export default {
  name: "DonateApply",
  components: {
    DxTextBox,
    DxValidationGroup,
    DxValidator,
    DxRequiredRule,
    DxStringLengthRule,
    DxCustomRule,
  },
  data() {
    return {
      checkboxObj: {
        noname: false,
        checkedAll: false,
        checkedValues: [],
      },
      searchData: {
        ordNum: this.$route.query.ordNum || "",
      },
      searchedData: {
        ordNum: "",
        prchNum: 0,
        prchAmt: 0,
        jdgmAmt: 0,
        partDntnAmt: 0,
        dntnAmt: 0,
        product: {
          pgrpCd: "",
          modlNum: 0,
          modlNm: "",
          cate01Num: 0,
          cate01Nm: "",
          mobile: false,
        },
      },
      donate: {
        ordNum: "",
        dntnCstmNm: "",
        dntnCstmIdntNum: "",
        dntnCstmAddr: "",
        agrees: [],
      },
      donateResponse: {
        SUCCESS: "기부신청이 완료 되었습니다.",
        INVAILD_NUMBER: "주민번호가 유효하지 않습니다.",
        NOT_AGREE: "필수사항에 모두 동의하셔야 기부하실수 있습니다.",
        EXIST: "이미 기부 신청 되었습니다.",
        FAIL: "기부신청시 오류가 발생하였습니다.",
      },
    };
  },
  watch: {
    donate: {
      deep: true,
      handler(obj) {},
    },
  },
  filters: {
    currency(amt) {
      return String(amt).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  methods: {
    async init() {
      this.search();
    },
    async search() {
      if (!this.searchData.ordNum) {
        this.$Alert.alert("주문번호가 존재하지 않습니다.");
        // TODO 주문번호 없는 경우 처리
        return;
      }
      Vue.httpClient
        .get(`/api/purchase/public/donate/apply/${this.searchData.ordNum}`, {})
        .then((response) => {
          if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            Object.assign(this.searchedData, response.data.result);
          }
        })
        .catch((error) => {
          console.error("error ::", error);
          this.$Alert.alert("조회시 오류가 발생하였습니다.");
        });
    },
    onNonameChecked(checked) {
      if (checked) {
        Object.assign(this.donate, {
          dntnCstmNm: "무기명",
          dntnCstmIdntNum: "",
          dntnCstmAddr: "",
        });
      } else {
        Object.assign(this.donate, {
          dntnCstmNm: "",
          dntnCstmIdntNum: "",
          dntnCstmAddr: "",
        });
      }
    },
    onlyNumber(e) {
      const value = e.event.target.value;
      e.event.target.value = value.replace(/[^0-9]/g, "");
    },
    onCheckboxAllChanged(checked) {
      if (checked) {
        this.checkboxObj.checkedValues = ["01", "02", "03", "04", "05"];
      } else {
        this.checkboxObj.checkedValues = [];
      }
    },
    onCheckboxChanged() {
      if (this.checkboxObj.checkedValues.length === 5) {
        this.checkboxObj.checkedAll = true;
      } else {
        this.checkboxObj.checkedAll = false;
      }
    },
    validAccount() {
      if (!this.checkboxObj.noname) {
        const calculate = ["5", "6", "7", "8"].includes(
          this.donate.dntnCstmIdntNum.substr(6, 1)
        )
          ? 13
          : 11;
        const checkSum = [...Array(12).keys()].reduce(
          (x, y) =>
            x + (this.donate.dntnCstmIdntNum.substr(y, 1) >> 0) * ((y % 8) + 2),
          0
        );
        if (
          String((calculate - (checkSum % 11)) % 10) !==
          this.donate.dntnCstmIdntNum.substr(12, 1)
        ) {
          return false;
        }
      }
      return true;
    },
    async donateApply() {
      // 소득공제 신청 체크
      const validate = this.$refs["validationGroup"].instance.validate();
      if (!validate.isValid) {
        // this.$Alert.alert(validate.brokenRules[0].message)
        validate.brokenRules[0].validator.focus();
        return;
      }

      // 동의 여부 체크
      if (this.checkboxObj.checkedValues.length < 5) {
        this.$Alert.alert("필수사항에 모두 동의하셔야 기부하실수 있습니다.");
        this.$refs["check-00"].focus();
        return;
      }

      const paramObj = {
        ...JSON.parse(
          JSON.stringify(
            Object.assign(this.donate, {
              ordNum: this.searchedData.ordNum,
              agrees: this.checkboxObj.checkedValues,
            })
          )
        ),
      };

      const isTrue = await this.$Alert.confirm("기부신청 하시겠습니까?");
      if (isTrue) {
        Vue.httpClient
          .post("/api/purchase/public/donate/save", paramObj)
          .then((response) => {
            this.$Alert.alert(this.donateResponse[response.data.result]);
            // 성공일 경우 완료 페이지 이동
            if (Object.keys(this.donateResponse)[0] === response.data.result) {
              this.$router.push({
                name: "donateComplete",
                query: { ordNum: this.searchedData.ordNum },
              });
            }
          })
          .catch((error) => {
            console.error("error ::", error);
            if (error.status === 400) {
              this.$Alert.alert(error.data.result.message);
            } else {
              this.$Alert.alert(this.donateResponse.FAIL);
            }
          });
      }
    },
  },
  async mounted() {
    this.init();
    await this.$nextTick();

    setTimeout(function () {}, 3000);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/views/purchase/DonateApply.vue